import { isGif, isVideo } from "./fileHelper";
import {
  IMusic,
  IShareLinkMetadata,
  IUserProfile,
} from "../common/commonTypes";
import { TwitterCardType } from "../common/commonEnums";
import { getPosterUrl } from "./videoHelper";

export const getUserPageMetadata = (user: IUserProfile): IShareLinkMetadata => {
  const primaryImage = user.profile.image_profile?.url;
  const secondaryImage =
    user.profile.image_background?.url || user.profile.image_cover?.url;

  const metadata = {
    previewTitle: "Check out my musician profile on NOIZD 😎",
    previewDescription: user.username,
    previewOgImage: primaryImage,
    previewTwitterImage: primaryImage,
    twitterCardType: TwitterCardType.summary,
  };

  if (!user.profile.image_profile || isGif(user.profile.image_profile.mime)) {
    return {
      ...metadata,
      previewOgImage: secondaryImage,
      previewTwitterImage: secondaryImage,
      twitterCardType: TwitterCardType.summaryLarge,
    };
  }

  return metadata;
};

export const getAssetPageMetadata = (music: IMusic): IShareLinkMetadata => {
  const primaryImage = music.cover.url;
  const secondaryImage = music.poster?.url;

  const metadata = {
    previewTitle: music.title,
    previewDescription: music.artist.username,
    previewOgImage: primaryImage,
    previewTwitterImage: primaryImage,
    twitterCardType: TwitterCardType.summary,
  };

  if (isVideo(music.cover.mime)) {
    const posterUrl = getPosterUrl(music.cover.url);

    return {
      ...metadata,
      previewOgImage: posterUrl,
      previewTwitterImage: posterUrl,
    };
  }

  if (isGif(music.cover.mime)) {
    return {
      ...metadata,
      previewOgImage: secondaryImage,
      previewTwitterImage: secondaryImage,
      twitterCardType: TwitterCardType.summaryLarge,
    };
  }

  return metadata;
};
